import styled, { css } from 'styled-components';
import { styles } from '../constants/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { getScrollIndicatorLuminosity } from '../Tabs/styles.js';
import { timings } from '../constants/timings.js';
import { getContentSwitcherHoverBackground } from './utils.js';
import { px2rem } from '../utils/helpers/style.js';
import { themeVariant } from '../utils/helpers/themeVariant.web.js';

var getContentSwitcherHoverStyle = function getContentSwitcherHoverStyle(props) {
  return css(["color:", ";background:", ";transition:background ", ";transition-timing-function:", ";"], props.$color, getContentSwitcherHoverBackground(props.$color, props.theme.contentSwitcher.web.background), styles.transition.timing.fastest, styles.transition["function"].base);
};
var button = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__button",
  componentId: "sc-2j3uyg-0"
})(["", ";text-decoration:none;outline:none;margin:0;display:flex;justify-content:center;align-items:center;position:relative;height:100%;border:none;border-radius:", ";", " ", " font-size:", ";line-height:", ";text-align:center;transition:color ", ",background ", ";transition-timing-function:", ";&:enabled:hover{cursor:pointer;}&:enabled:focus-visible{box-shadow:0 0 0 4px ", ";outline:2px solid ", ";outline-offset:0;}&:disabled{cursor:not-allowed;}padding:0 ", ";", "{padding:0 ", ";}", ""], fontFamilyStyles, function (props) {
  return props.theme.borders.radius && parseFloat(props.theme.borders.radius) > 0 && px2rem(2);
}, function (props) {
  return props.$stretchOnMobile && css(["", "{flex:1;}"], styles.breakpointMax.m);
}, function (props) {
  return css(["background:", ";color:", ";z-index:", ";"], props.$active ? props.$color : 'transparent', props.$active ? props.theme.contentSwitcher.web.active.textColor : props.disabled ? props.theme.tokens.text.disabled : props.theme.colors.text, props.$active ? 1 : 0);
}, themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.contentSwitcher.web.font.size[props.$size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.contentSwitcher.web.font.size.s);
  }
}), px2rem(44), styles.transition.timing.slower, styles.transition.timing.slower, styles.transition["function"].base, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
}, function (p) {
  return p.theme.contentSwitcher.web.paddings.mobile;
}, styles.breakpoint.s, function (p) {
  return p.theme.contentSwitcher.web.paddings.desktop;
}, function (props) {
  return !props.$active && css(["&:enabled:focus,&:enabled:hover{", "}"], getContentSwitcherHoverStyle);
});
var scrollIndicator = /*#__PURE__*/css(["width:30px;height:100%;position:absolute;z-index:2;opacity:0;pointer-events:none;content:'';transition:opacity ", ";background:transparent;"], timings.slower);
var tabs = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__tabs",
  componentId: "sc-2j3uyg-1"
})(["box-sizing:border-box;display:flex;overflow-x:auto;overflow-y:hidden;white-space:nowrap;margin:0;align-items:center;list-style:none;border-radius:", ";background:", ";padding:", ";max-width:min-content;height:", ";&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;&:after{margin-left:auto;right:0;top:0;box-shadow:inset -10px 0 8px -8px ", ";", "}&:before{margin-right:auto;left:0;top:0;box-shadow:inset 10px 0 8px -8px ", ";", "}", " ", ""], function (props) {
  return props.$borderRadius;
}, function (props) {
  return props.theme.contentSwitcher.web.background;
}, px2rem(4), themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.contentSwitcher.web.height[props.$size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.contentSwitcher.web.height.s);
  }
}), function (p) {
  return getScrollIndicatorLuminosity(p.theme.contentSwitcher.web.background);
}, scrollIndicator, function (p) {
  return getScrollIndicatorLuminosity(p.theme.contentSwitcher.web.background);
}, scrollIndicator, function (p) {
  return p.$scrolling && !p.$scrollEndRight && css(["&:after{opacity:1;}"]);
}, function (p) {
  return p.$scrolling && !p.$scrollEndLeft && css(["&:before{opacity:1;}"]);
});
var text = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__text",
  componentId: "sc-2j3uyg-2"
})(["padding-left:", ";"], function (p) {
  return p.$useActiveIcon && p.theme.contentSwitcher.web.paddings.mobile;
});
var separator = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__separator",
  componentId: "sc-2j3uyg-3"
})(["background:", ";min-width:1px;height:50%;"], function (p) {
  return p.$visible ? 'transparent' : p.theme.contentSwitcher.web.separator;
});

export { button, separator, tabs, text };
